import { render, staticRenderFns } from "./FirmaNastaveni2.vue?vue&type=template&id=00648414&"
import script from "./FirmaNastaveni2.vue?vue&type=script&lang=ts&"
export * from "./FirmaNastaveni2.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports